<template>
    <index-table
        :cols="[
            {
                value: 'name',
                label: 'Name',
                sortable: true,
                searchable: true,
            },
            {
                value: 'uuid',
                label: 'UUID',
                sortable: true,
                searchable: true,
            },
            {
                value: 'organization_unique_id',
                label: 'Key ID',
                sortable: true,
                searchable: true,
            },
            {
                value: 'created_at',
                label: 'Created',
                sortable: true,
                searchable: false,
                filter: 'localDate',
            },
        ]"
        :title="'Encryption Keys'"
        :model="'encryption-keys'"
        :createText="'Create Encryption Key'"
        :deleteHandler="deleteHandler"
        :options="['deletable']"
    />
</template>

<script>
import canConfirm from '@/mixins/canConfirm'
import IndexTable from '@/components/IndexTable/index.vue'
import canToast from '@/mixins/canToast'
import needsOrganizationSlug from '@/mixins/needsOrganizationSlug'

export default {
    components: {
        IndexTable,
    },

    mixins: [canConfirm, canToast, needsOrganizationSlug],

    methods: {
        async deleteHandler(keys, showDefaultConfirmation, performDelete) {
            const many = keys.length > 1
            const anyKeyIsInConfigurationSet = keys.some((key) => key.is_in_configuration_set)

            const confirmed = await this.confirm({
                message: many
                    ? 'Are you sure you want to delete the selected Encryption Keys? This action cannot be undone.'
                    : 'Are you sure you want to delete this Encryption Key? This action cannot be undone.',
                hint: anyKeyIsInConfigurationSet
                    ? `Note: Deleting ${many ? 'these Encryption Keys' : 'this Encryption Key'} won’t affect ` +
                      `existing Configuration Sets using ${many ? 'them' : 'it'}.`
                    : null,
                acceptLabel: 'Delete',
                danger: true,
            })

            if (confirmed) {
                performDelete(keys.map((g) => g.id))
            }
        },
    },
}
</script>
